// Komponenty przycisków akcji (narzut globalny, więcej opcji)

import React, { useState } from "react";
import { useAccommodation } from "../../AccommodationProvider";
import GlobalMarkupModal from "../Modals/GlobalMarkupModal";
import { toFiniteNumber } from "../../../../utils/markupCalculations";

const ActionButtons: React.FC = () => {
  const { markup } = useAccommodation();
  const [isMarkupModalOpen, setIsMarkupModalOpen] = useState(false);

  // Handlery
  const handleGlobalMarkup = () => {
    setIsMarkupModalOpen(true);
  };

  const handleMoreOptions = () => {
    console.log("Open More Options Modal");
    // TODO: Otworzyć MoreOptionsModal
  };

  return (
    <div className="flex items-center justify-center lg:justify-start gap-4 pt-4 border-t border-gray-200">
      {/* Przycisk narzutu globalnego */}
      <button
        onClick={handleGlobalMarkup}
        className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
      >
        <span>💰</span>
        <span>Ustaw globalny narzut/rabat</span>
        {markup && toFiniteNumber(markup.accommodationMarkupValue) !== 0 && (
          <span className="ml-1 px-2 py-0.5 text-xs bg-blue-500 rounded-full">
            {markup.accommodationMarkupValue}
            {markup.accommodationMarkupType === "percentage" ? "%" : "zł"}
          </span>
        )}
      </button>

      {/* Przycisk więcej opcji - ukryty */}
      <button
        onClick={handleMoreOptions}
        className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
        style={{ display: "none" }}
      >
        <span>⚙️</span>
        <span>Więcej opcji</span>
        <span className="ml-1 text-xs text-gray-400">▼</span>
      </button>

      {/* Modal globalnego narzutu */}
      <GlobalMarkupModal
        isOpen={isMarkupModalOpen}
        onClose={() => setIsMarkupModalOpen(false)}
      />
    </div>
  );
};

export default ActionButtons;
